import { DateTime } from "luxon";
import { DATE_ONLY_PATTERN, toUTCFormat } from "@/lib/dateHelpers";
import type { DateOfBirth, Person } from "@/types";

export const EMAIL_IDENTITY_NOT_ON_FILE = "Not on file";

export const EMAIL_IDENTITY_CHECK_DESCRIPTION = "Please confirm the following information with the member.";

export const EMAIL_IDENTITY_CHECK_SUBTEXT = "They should be able to confirm all values.";

export const EMAIL_IDENTITY_DIALOG_HEADLINE = "Confirm identity before you change this email";

export const EMAIL_IDENTITY_SAVE_HINT = "Saving updates Auth0 and sends a verify email message.";

export type EmailIdentityCheckPerson = Pick<Person, "pgaId" | "email" | "dob" | "membershipSince">;

export type EmailIdentityCheckRow = {
  label: string;
  value: string;
};

export function formatDateOfBirthForIdentityCheck(dob?: DateOfBirth | null): string {
  const { day, month, year } = dob ?? {};
  if (!day || !month) {
    return EMAIL_IDENTITY_NOT_ON_FILE;
  }

  const date = DateTime.fromObject({ day, month, year });
  if (!date.isValid) {
    return EMAIL_IDENTITY_NOT_ON_FILE;
  }

  return year ? date.toFormat("MMM d, yyyy") : date.toFormat("MMM d");
}

export function formatElectionOrRegistrationYear(membershipSince?: string | null): string {
  if (!membershipSince) {
    return EMAIL_IDENTITY_NOT_ON_FILE;
  }

  if (DATE_ONLY_PATTERN.test(membershipSince)) {
    return membershipSince.slice(0, 4);
  }

  return toUTCFormat(membershipSince, "yyyy") ?? EMAIL_IDENTITY_NOT_ON_FILE;
}

export function emailIdentityCheckRows(person: EmailIdentityCheckPerson): EmailIdentityCheckRow[] {
  return [
    { label: "PGA ID", value: person.pgaId?.trim() || EMAIL_IDENTITY_NOT_ON_FILE },
    { label: "Date of birth", value: formatDateOfBirthForIdentityCheck(person.dob) },
    { label: "Email on file", value: person.email?.trim() || EMAIL_IDENTITY_NOT_ON_FILE },
    {
      label: "Year of election or registration",
      value: formatElectionOrRegistrationYear(person.membershipSince)
    }
  ];
}
